import { useEffect, useState } from "react";
import Select from "react-select";
import CustomButton from "../../../../components/CustomButton";
import DetailsOrder from "../../../../components/DetailsOrder";
import { useNavigate, useParams } from "react-router-dom";
import PdfDownloadOrder from "../../../../components/PdfDownloadOrder";
import orders from "../../../../utils/pedidos";
import AddOrder from "../../../../components/AddOrders";
import useSupplierStore from "../../../../store/supplierStore";
import useOrderItemsStore from "../../../../store/orderItemsStore";
import api from "../../../../services/api";
import { v4 as uuidv4 } from "uuid";
import useAttachmentsStore from "../../../../store/attachmentsStore";
import { uploadFile } from "../../../../axios/uploadFiles";
import SpinnerLoading from "../../../../components/SpinnerLoading";
import SpinnerLoadingBlack from "../../../../components/SpinnerLoadingBlack";
import EditOrder from "../../../../components/EditOrder";

const Modal = ({ isOpen, onClose, title, message, isError }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-lg p-6">
        <h2
          className={`text-lg font-bold ${
            isError ? "text-red-600" : "text-green-600"
          }`}
        >
          {title}
        </h2>
        <p className="mt-4 text-gray-700">{message}</p>
        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};
const EditarPedido = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [leadTime, setLeadTime] = useState("");
  const { id } = useParams();

  const { getAllSuppliers, suppliers, loading, error } = useSupplierStore();
  const { orderItems, clearOrderItems, setOrderItems } = useOrderItemsStore();
  const [supplier, setSupplier] = useState("");

  const { addAttachment, clearAttachments, attachments } =
    useAttachmentsStore();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [isLoadingPdfUpload, setIsLoadingPdfUpload] = useState(false);
  const [order, setOrder] = useState({});

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(`/orders/${id}`);
        setOrder(response.data);
        setSupplier(response.data.supplier_name);
        setLeadTime(response.data.lead_time);
        setOrderItems(response.data.order_Items);
      } catch (error) {
        console.error("Erro ao obter pedido: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchOrder();
    clearAttachments();
  }, []);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        alert("Por favor, selecione um arquivo PDF.");
        return;
      }

      const MAX_FILE_SIZE = 5 * 1024 * 1024;
      if (file.size > MAX_FILE_SIZE) {
        alert("O arquivo excede o tamanho máximo permitido de 5MB.");
        return;
      }

      const tempReferenceId = uuidv4();
      setIsLoadingPdfUpload(true);
      try {
        const response = await uploadFile(file);
        const dbAttachmentsPost = {
          google_id: response.result.id,
          reference_id: tempReferenceId,
          reference_type: "TEMP",
          attachment_type: "ORDER_ATTACHMENT",
          attachment_description: response.result.name,
          privacy: "PUBLIC",
        };
        await api.post(`/attachments/create-attachment`, dbAttachmentsPost);

        addAttachment(dbAttachmentsPost.reference_id);
        const currentAttachments = useAttachmentsStore.getState().attachments;
        console.log("Estado atualizado no Zustand:", currentAttachments);

        console.log("Resposta da API:", response);
      } catch (error) {
        console.error("Erro ao enviar o arquivo:", error);
        alert(
          "Erro ao enviar o arquivo. Habilite o pop-up no seu navegador, ou sua conexão com a internet."
        );
      } finally {
        setIsLoadingPdfUpload(false);
      }
    }
  };

  useEffect(() => {
    getAllSuppliers();
  }, [getAllSuppliers]);

  useEffect(() => {
    console.log(supplier);
  }, [supplier]);

  const handleChange = (selectedOption) => {
    setSupplier(selectedOption.label);
  };
  const validateNumericInput = (e) => {
    const inputValue = e.target.value.replace(/\D/g, "");
    return inputValue;
  };

  const handleChangeLeadTime = (e) => {
    const formatedValueNumber = validateNumericInput(e);
    setLeadTime(formatedValueNumber);
  };

  const handleNavigate = () => {
    navigate(`/pedidos/detalhes/${id}`);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#E8E9EB",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
    }),
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      for (const orderItem of orderItems) {
        orderItem.total_value = parseFloat(
          orderItem.target_value * orderItem.quantity
        ).toFixed(2);
        orderItem.target_value = parseFloat(orderItem.target_value).toFixed(2);
        orderItem.unit_value = parseFloat(orderItem.unit_value).toFixed(2);
        orderItem.quantity = parseInt(orderItem.quantity, 10);
        if (orderItem.product_name) {
          orderItem.name = orderItem.product_name;
          delete orderItem.product_name;
        }
        if (orderItem.product_id) {
          orderItem.id = orderItem.product_id;
          delete orderItem.product_id;
        }
        orderItem.id = parseInt(orderItem.id);
        delete orderItem.quantity_loaded;
        delete orderItem.remaining_quantity;
        delete orderItem.total_unit_value;
        delete orderItem.product;
        delete orderItem.total_target;
        delete orderItem.total_target;
        delete orderItem.order_id;
      }

      const updatedData = {
        supplier: supplier,
        lead_time: Number(leadTime),
        order_items: orderItems,
      };

      const orderRes = await api.put(`/orders/${id}`, updatedData);

      setModalTitle("Sucesso!");
      setModalMessage("Pedido atualizado com sucesso!");
      setIsErrorModal(false);
      setModalOpen(true);

      const orderId = orderRes.data.id;

      if (attachments.length > 0) {
        await api.put("/attachments/update-reference", {
          temp_reference_ids: attachments,
          order_id: orderId,
          reference_type: "ORDER",
        });

        clearAttachments();
      }
    } catch (error) {
      const errorMessage =
        error.response?.status !== 500
          ? error.response?.data?.error || "Erro desconhecido."
          : "Ocorreu um erro no servidor. Por favor, tente novamente mais tarde.";

      setModalTitle("Erro!");
      setModalMessage(errorMessage);
      setIsErrorModal(true);
      setModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
          navigate("/pedidos");
        }}
        title={modalTitle}
        message={modalMessage}
        isError={isErrorModal}
      />
      <div className="w-full">
        <form onSubmit={onHandleSubmit}>
          <div className="justify-between flex my-2">
            <div className="flex items-center">
              <div className="w-[180px]">
                <CustomButton
                  className="bg-primary text-white font-semibold"
                  onClick={handleNavigate}
                >
                  Voltar
                </CustomButton>
              </div>
            </div>

            <div className="flex justify-around items-center">
              <div className="xl:flex xl:items-center xl:ml-2">
                <p className="md:ml-2 xl:ml-0 font-bold">
                  Selecionar Fornecedor
                </p>
                <div className=" xl:ml-2">
                  {" "}
                  <Select
                    options={suppliers.map((supplier) => ({
                      value: supplier.id,
                      label: supplier.supplier_name,
                    }))}
                    onChange={handleChange}
                    placeholder={supplier}
                    styles={customStyles}
                  />
                </div>
              </div>

              <div className="xl:ml-4 xl:flex items-center justify-end">
                <p className="md:ml-6 xl:ml-0">
                  <strong>Lead Time</strong>
                </p>
                <div className="rounded-md bg-extraLightGray py-2 px-4 text-center ml-4 w-[122px] flex justify-evenly text-boldGray opacity-90">
                  <input
                    className="w-[40px] bg-transparent text-center outline-none"
                    placeholder="0"
                    value={leadTime}
                    onChange={handleChangeLeadTime}
                    required
                  />
                  dias
                </div>
              </div>
            </div>
          </div>

          <EditOrder orderItems={orderItems} />

          <div className=" w-full flex justify-between">
            <div className="2xl:w-[463px]">
              {isLoadingPdfUpload ? (
                <SpinnerLoadingBlack>Enviando PDF...</SpinnerLoadingBlack>
              ) : (
                <PdfDownloadOrder onUpload={handleFileUpload} />
              )}
            </div>

            <div className="2xl:w-[463px]">
              {isLoadingPdfUpload ? (
                <SpinnerLoadingBlack>Enviando PDF...</SpinnerLoadingBlack>
              ) : (
                <PdfDownloadOrder onUpload={handleFileUpload} />
              )}
            </div>
          </div>
          <div className="w-full flex justify-center">
            {" "}
            <div className="h-[62px] w-[236px]">
              <CustomButton
                type="submit"
                className="text-xl bg-primary text-white font-bold"
              >
                {isLoading ? (
                  <SpinnerLoading>Salvando...</SpinnerLoading>
                ) : (
                  "Salvar pedido"
                )}
              </CustomButton>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditarPedido;
